import { CartCheckoutPatternEnum } from "@officexapp/types";

const LOCALE = {
  ["ti"]: {
    helmet: {
      chat: "ምትዕላል | OfficeX",
      purchase_history: "ታሪኽ ምግዛእ",
      appstore: "ማዕከን ኣፕሊኬሽን",
      folder: "ፋይል",
      file: "ሰነድ",
      settings: "ቅንብራት",
    },
    default_disks: {
      browser_cache: {
        title: "ናይ ምድላው ካሽ ኣፍታሒ",
        public_note:
          "ናይ ምድላው ካሽ ኣፍታሒ ብሞባይል መረብ ምትእስሳር ንኽትጥቀመሉ ዝሕግዝ ናይ ኢንተርኔት ኣፍታሒ። እቲ ፍይላዊ ናይ ኢንተርኔት ኣፍታሒ ታሪኽ ንምእላይ እቲ ፍይላዊ ይሰረዝ።",
      },
      free_cloud_filesharing: {
        title: "ናይ ምድላው ካሽ ኣፍታሒ",
        public_note:
          "ብምሉእ ድምፂ ዝተሓተ መርሃ ግብሪ። እቲ ፍይላዊ ኣብ 24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።",
      },
      folders: {
        root: "ንኡስ",
        throwaway: "ብሰማይ",
        demo_gallery: "ምስሊ",
        tutorial_videos: "ናይ ምህርቲ",
      },
    },
    default_orgs: {
      offline_org: {
        org_name: "ናይ ምድላው ኣገባብ",
        profile_name: "ኣብራ",
      },
      anon_org: {
        org_name: "ኣብራ",
        profile_name: "ኣብራ",
      },
    },
    appstore: {
      input_placeholders: {
        search_mall: "ኣፕሊኬሽን፣ ኣብራ፣ ኣብራን ኣገልግሎት ንምግዛእ...",
        search_offers: "ብምሉእ ድምፂ ዝተሓተ መርሃ ግብሪ...",
      },
      s3_offer: {
        id: "19",
        name: "ናይ ምድላው ካሽ ኣፍታሒ",
        subheading: "ናይ OfficeX መርሃ ግብሪ ንምግዛእ $1 ኣብ 100GB/ወርሒ",
        cover_image:
          "https://cdn2.interfaz.io/wp-content/uploads/2023/06/Blog_AWS_cover-1.png",
        is_featured: false,
        offers: [
          {
            id: "offer1-aws-s3-ai-csv-expodrt",
            title: "100GB መርሃ ግብሪ",
            images: [],
            description:
              "<p>ናይ 100GB መርሃ ግብሪ ንምግዛእ Amazon Cloud. እቲ ፍይላዊ ብAWS S3 ዝተሓተ መርሃ ግብሪ ኮይኑ ንምግዛእ ንጥቀመሉ ኢና። እቲ ፍይላዊ ኣብ 24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።</p><p>ብAWS S3 Intelligent-Tiering ዝተሓተ መርሃ ግብሪ እቲ ፍይላዊ ንምግዛእ ንጥቀመሉ ኢና። እዚ ኸኣ ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና።</p><ul><li>ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና። $0.0054/GB ኣብ ወርሒ።</li><li>ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና። $0.03128/GB ኣብ ወርሒ።</li></ul><p>እቲ ፍይላዊ ንምግዛእ $0.1224 ኣብ GB ይሕተ።</p><p>ናይ OfficeX መርሃ ግብሪ ንምግዛእ ንጥቀመሉ ኢና። እቲ ፍይላዊ ብ24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።</p>",
            price: 0.01,
            price_unit: "/GB",
            price_explanation: "ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና። $1",
            bookmarks: 180,
            bookmarked_demand: 240000,
            cumulative_sales: 105000,
            bookmark_url: "",
            call_to_action: "ኣብራ",
            vendors: [
              {
                id: "vendorA",
                name: "Cloud Solutions Inc.",
                avatar: "https://api.dicebear.com/7.x/initials/svg?seed=CS",
                checkout_video:
                  "https://www.youtube.com/embed/ecv-19sYL3w?si=4jQ6W1YuYaK7Q4-k",
                uptime_score: 99.99,
                reviews_score: 4.8,
                community_links: [
                  {
                    label: "ምትዕላል",
                    url: "#",
                  },
                  {
                    label: "ምትዕላል",
                    url: "#",
                  },
                ],
                price_line: "$0.01/GB/ወርሒ",
                view_page_link: "#",
                call_to_action: "ኣብራ",
                description:
                  "ናይ OfficeX መርሃ ግብሪ ንምግዛእ ንጥቀመሉ ኢና። እቲ ፍይላዊ ብ24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።",
                vendor_disclaimer: "",
                about_url: "https://vendor.com",
                checkout_options: [
                  {
                    offer_id: "aws-s3-storage-giftcard",
                    checkout_flow_id:
                      "001_amazon_storage_crypto_wallet_topup_gift_card_only",
                    title: "USDC on Base",
                    note: "ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና። እቲ ፍይላዊ ብ24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።",
                    checkout_init_endpoint:
                      "https://vendorofficex.otterpad.cc/v1/checkout/initiate",
                    checkout_pattern:
                      CartCheckoutPatternEnum.CRYPTO_WALLET_TOPUP,
                    vendor_notes: "እቲ ፍይላዊ ንምግዛእ ንጥቀመሉ ኢና። AWS S3",
                    vendor_disclaimer:
                      "ናይ ምድላው ካሽ ኣፍታሒ ንምግዛእ ንጥቀመሉ ኢና። እቲ ፍይላዊ ብ24 ሰዓት ይተሓተ ምዃኑ ኸኣ ኣብ 24 ሰዓት ምሉእ ድምፂ ይገብር።",
                    terms_of_service_url: "https://google.com",
                    requires_email_for_init: true,
                    about_url: "https://vendor.com",
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  },
};
export default LOCALE;
